var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.904 0.206C15.81 0.0769999 15.66 0 15.5 0H2.5C1.837 0 1.201 0.263 0.732 0.732C0.263 1.201 0 1.837 0 2.5C0 6.684 0 16.316 0 20.5C0 21.163 0.263 21.799 0.732 22.268C1.201 22.737 1.837 23 2.5 23C6.332 23 14.668 23 18.5 23C19.163 23 19.799 22.737 20.268 22.268C20.737 21.799 21 21.163 21 20.5C21 16.39 21 7.375 21 7.375C21 7.269 20.967 7.166 20.904 7.081L15.904 0.206ZM15.245 1H2.5C2.102 1 1.721 1.158 1.439 1.439C1.158 1.721 1 2.102 1 2.5C1 6.684 1 16.316 1 20.5C1 20.898 1.158 21.279 1.439 21.561C1.721 21.842 2.102 22 2.5 22C6.332 22 14.668 22 18.5 22C18.898 22 19.279 21.842 19.561 21.561C19.842 21.279 20 20.898 20 20.5V7.538L15.245 1Z",
    fill: "#5956E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 6H10.5C10.776 6 11 5.776 11 5.5C11 5.224 10.776 5 10.5 5H3.5C3.224 5 3 5.224 3 5.5C3 5.776 3.224 6 3.5 6Z",
    fill: "#E541ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8H20.5C20.776 8 21 8.224 21 8.5C21 8.776 20.776 9 20.5 9H15.5C15.224 9 15 8.776 15 8.5V0.5C15 0.224 15.224 0 15.5 0C15.776 0 16 0.224 16 0.5V8Z",
    fill: "#5956E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 11H10.5C10.776 11 11 10.776 11 10.5C11 10.224 10.776 10 10.5 10H3.5C3.224 10 3 10.224 3 10.5C3 10.776 3.224 11 3.5 11Z",
    fill: "#E541ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 15.5H13.5C13.776 15.5 14 15.276 14 15C14 14.724 13.776 14.5 13.5 14.5H3.5C3.224 14.5 3 14.724 3 15C3 15.276 3.224 15.5 3.5 15.5Z",
    fill: "#E541ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.71d8b4631d9e442663de3807a6442264.svg";
export { ForwardRef as ReactComponent };